import libs from './external'; // unused-warning is not real. This line is required for app to function

import uiRouter from 'angular-ui-router';

import '../css/main.css';

import {appDirective} from './app.directive';

import {components} from './components/components';
import {shared} from './shared/shared';
import {models} from './models/models';

angular.module('app', [
  uiRouter,
  'ngSanitize',
  'ngAnimate',
  'ui.bootstrap',
  'ngCookies',
  components.name,
  shared.name,
  models.name
]).config(function ($httpProvider) {
  // Enable cross domain calls
  $httpProvider.defaults.useXDomain = true;
}).directive('app', appDirective);



/** WEBPACK FOOTER **
 ** ./src/app/app.js
 **/